import React from "react";
import { List, Card, Typography, Button, Empty } from "antd";
import PropTypes from "prop-types";
import { useLocation, useNavigate } from "react-router-dom";

const { Text } = Typography;

export const PendingRequests = () => {
  const location = useLocation();
  const { darkMode = false, pendingRequests } = location.state || {};
  const navigate = useNavigate();
  const styles = {
    card: {
      borderRadius: 8,
      marginBottom: 24,
      backgroundColor: darkMode ? "#1f1f1f" : "#fff",
      borderColor: darkMode ? "#303030" : "#f0f0f0",
    },
    cardTitle: {
      color: darkMode ? "rgba(255, 255, 255, 0.85)" : undefined,
    },
    trainingCard: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
    },
    listItem: {
      padding: "8px 0",
      borderBottom: `1px solid ${darkMode ? "#303030" : "#f0f0f0"}`,
    },
    textColor: {
      color: darkMode ? "rgba(255, 255, 255, 0.85)" : undefined,
    },
    secondaryTextColor: {
      color: darkMode ? "rgba(255, 255, 255, 0.45)" : "rgba(0, 0, 0, 0.45)",
    },
    noData: {
      textAlign: "center",
      padding: "24px 0",
      color: darkMode ? "rgba(255, 255, 255, 0.45)" : "#999",
    },
  };

  return (
    <Card
      title="Pending Training Requests"
      style={{ ...styles.card, ...styles.trainingCard }}
      headStyle={styles.cardTitle}
      extra={
        <Button type="default" onClick={() => navigate(-1)}>
          Back
        </Button>
      }
    >
      {pendingRequests.length === 0 ? (
         <Empty description="No Pending Request Available yet!" />
      ) : (
        <List
          size="small"
          dataSource={pendingRequests.slice(0, 3)}
          renderItem={(request) => (
            <List.Item style={styles.listItem}>
              <List.Item.Meta
                title={
                  <Text strong style={styles.textColor}>
                    {request.title}
                  </Text>
                }
                description={
                  <>
                    <Text style={styles.secondaryTextColor}>
                      Learner: {request.learnerFirstName} {request.learnerLastName}
                    </Text>
                    <br />
                    <Text style={styles.secondaryTextColor}>
                      Manager: {request.managerFirstName} {request.managerLastName}
                    </Text>
                  </>
                }
              />
            </List.Item>
          )}
        />
      )}
    </Card>
  );
};

PendingRequests.propTypes = {
  darkMode: PropTypes.bool.isRequired,
  pendingRequests: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      learnerFirstName: PropTypes.string.isRequired,
      learnerLastName: PropTypes.string.isRequired,
      managerFirstName: PropTypes.string.isRequired,
      managerLastName: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
};
